import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {TranslateService} from "../../../shared/translate.service";
import {AppConfigService} from "../../../config/app-config.service";
import {HtmlUtilsService} from "../../../html-utils/html-utils.service";

@Component({
  selector: 'app-nav-lang-list',
  templateUrl: './nav-lang-list.component.html',
  styleUrls: ['./nav-lang-list.component.scss']
})
export class NavLangListComponent implements OnInit {

  @Input() showLang = false;

  @Output("chosenLangEmitter") chosenLangEmitter: EventEmitter<any> = new EventEmitter();

  languages: string[] = [];

  chosenLang: string;

  constructor(private appConfig: AppConfigService,
              public translateService: TranslateService,
              private htmlUtils: HtmlUtilsService) {
  }

  ngOnInit() {
    this.appConfig.languages.forEach(value => {
      if (value.active) {
        this.languages.push(value.name);
      }
    });
    this.setLang('PL');
    this.htmlUtils.defaultLang.subscribe(defLang => {
      this.setLang(defLang);
    });
  }

  chooseLang($event) {
    this.chosenLang = $event.target.textContent;
    this.translateService.setLang(this.chosenLang);
    this.chosenLangEmitter.emit(this.chosenLang);
  }

  private setLang(paramLang) {
    this.showLang = false;
    let localStorageLang = localStorage.getItem('LANGUAGE');
    if (localStorageLang) {
      this.chosenLang = localStorageLang;
    } else {
      this.chosenLang = paramLang;
    }
    this.translateService.setLang(this.chosenLang, false);
    this.chosenLangEmitter.emit(this.chosenLang);
  }
}
